import script from "./AtomAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomAccordion.vue?vue&type=script&lang=ts&setup=true"

import "./AtomAccordion.vue?vue&type=style&index=0&id=0e202b92&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e202b92"]])

export default __exports__